import { FC, PropsWithChildren, ReactNode, RefObject, useCallback, useEffect, useRef } from "react";
import { Card } from "./Card";
import "./Dropdown.scss";

export interface DropdownProps {
  // eslint-disable-next-line
  readonly refToFocus?: RefObject<any>;
  readonly label: ReactNode;
  readonly isOpen?: boolean;
  readonly onBlur?: () => void;
  readonly onClick?: () => void;
  readonly keepTitleFocusedOnMenuClose?: boolean;
}

export const Dropdown: FC<PropsWithChildren<DropdownProps>> = ({
  refToFocus,
  label,
  isOpen,
  onBlur,
  onClick,
  children,
  keepTitleFocusedOnMenuClose = false,
}) => {
  const menuRef = useRef<HTMLDivElement>();

  const onTitleClick = useCallback(
    (e: React.MouseEvent) => {
      e.preventDefault();
      onClick && onClick();
    },
    [onClick],
  );

  const onMouseDown = useCallback(
    (e: React.MouseEvent) => {
      e.preventDefault();
      onClick && onClick();
    },
    [onClick],
  );

  const onContentBlur = useCallback(
    (e: React.FocusEvent) => {
      e.preventDefault();
      if (isOpen) {
        onBlur && onBlur();
      }
    },
    [onBlur, isOpen],
  );

  useEffect(() => {
    if (isOpen) {
      if (refToFocus) {
        refToFocus?.current?.focus();
      } else {
        menuRef?.current?.focus();
      }
    }
    if (keepTitleFocusedOnMenuClose) {
      if (refToFocus) {
        refToFocus?.current?.focus();
      } else {
        menuRef?.current?.focus();
      }
    }
  }, [isOpen, refToFocus]);

  return (
    <div className="enrollment-dropdown-container" onBlur={onContentBlur}>
      {isOpen && <div className="enrollment-dropdown-label-button" onMouseDown={onMouseDown}>{label}</div>}
      {!isOpen && <div className="enrollment-dropdown-label-button" onClick={onTitleClick}>{label}</div>}
      {isOpen && (
        <div className="enrollment-dropdown-content" ref={menuRef} tabIndex={0}>
          <Card>{children}</Card>
        </div>
      )}
    </div>
  );
};
